import './tour.scss';
import Shepherd from 'tether-shepherd';
import map from '../map';

let tour = new Shepherd.Tour({
    defaults: {
        classes: 'shepherd-theme-arrows feature-tour'
    },
});

// general welcome message
tour.addStep('welcome', {
    showCancelLink: true,
    text: require('./tourWelcome.html'),
    title: 'Welcome!',
    buttons: [
        {
            action: tour.cancel,
            classes: 'btn btn-secondary',
            text: 'Close',
        },
        {
            action: tour.next,
            classes: 'btn',
            text: 'Show me how',
        },
    ],
});

// change types control
tour.addStep('types-filter', {
    attachTo: '#area-panel left',
    text: require('./tourTypesFilter.html'),
    title: 'Filter by forest change type',
});

// years slider control
tour.addStep('years-filter', {
    attachTo: 'g.resize.w top',
    text: require('./tourYearsFilter.html'),
    title: 'Filter by year',
    buttons: [{
        action: tour.next,
        classes: 'shepherd-button btn',
        text: 'OK!',
    }],
});

// start tour after app initializes
if (localStorage.getItem('tourComplete') !== '1') {
    map.once('load', function(){
        tour.start();
    });
}

// prevent tour from showing after completion
tour.on('complete', function(){
    localStorage.setItem('tourComplete', '1');
});



// WEBPACK FOOTER //
// ./src/js/tour/tour.js